export default __webpack_public_path__ + "static/media/ownBook.e781346d.svg";